import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewCityListPagination, editCity } from "../../Redux/Actions/settingsActions";
import { columnsCity } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";

const ListCity = () => {
  const { id } = useParams(); // state id
  const dispatch = useDispatch();

  const { citiesAllList } = useSelector((state) => state.city);
  const { states } = useSelector((state) => state.states);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
  const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

  const foundState = Array.isArray(states?.data) && states.data.find((item) => item._id === id);
  const countryId = foundState?.country;

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const fetchDetails = useCallback(
    async (page, pageSize, showLoader = true) => {
      const cityData = {
        page,
        limit: pageSize,
        state: id,
        country: countryId,
        is_deleted: false,
        filter: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      try {
        await dispatch(viewCityListPagination(cityData, showLoader));
        if (!showLoader) {
          toast.success("City list refreshed");
        }
      } catch {
        if (!showLoader) {
          toast.error("Failed to refresh city list");
        }
      }
    },
    [dispatch, id, countryId, debouncedSearch, dateRange]
  );

  const handleStatusChange = async (record, action) => {
    const payload = { id: record._id, status: action };
    await dispatch(editCity(record._id, payload));
    fetchDetails(pagination.current, pagination.pageSize);
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchDetails, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (citiesAllList?.data.total) {
      setPagination((prev) => ({ ...prev, total: citiesAllList.data.total }));
    }
  }, [citiesAllList]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <MainLayout>
      <div className="dashboard-container">
        <div className="table_component_all">
          <ListTopSearch
            h3heading={foundState?.state_name || "City List"}
            setState={setSearchQuery}
            buttonhead="Go Back"
            navigateTo={`/state-list/${countryId}`}
            buttonhead2={canAdd ? "Add City" : null}
            navigateTo2={canAdd ? `/city/${id}/add` : null}
            onCalendarClick={() => setIsDatePopupVisible(true)}
          />
          <div style={{ overflowX: "auto", padding: "0px 60px" }}>
            <Table
              dataSource={Array.isArray(citiesAllList?.data?.data) ? citiesAllList.data.data : []}
              pagination={pagination}
              onChange={handleTableChange}
              loading={citiesAllList?.loading}
              columns={columnsCity(pagination.current, pagination.pageSize, handleStatusChange, canEdit)}
            />
          </div>
        </div>
        <DateRangePopup
          visible={isDatePopupVisible}
          initialStart={dateRange.start}
          initialEnd={dateRange.end}
          onCancel={() => setIsDatePopupVisible(false)}
          onOk={handleDateRangeApply}
        />
      </div>
    </MainLayout>
  );
};

export default ListCity;